/**
 * Some clients (like the PDF export) need to be in a specific timezone.
 * This is the timezone that will be used by default.
 *
 * Unless Fairly-Score extends its business to international clients,
 * this should be set to 'Europe/Paris'.
 *
 * Please note in such case the best approach would be to localize times
 * also with the client's timezone at write time. In other words: the dates
 * are stored in GMT in the database, but should be computed in the client's
 * timezone prior to that save.
 */
export const forcedTimezone = 'Europe/Paris';
